import React, { useEffect } from 'react';
// import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import assets from 'assets';
// import { siteURL } from 'app.config';
import { config } from 'container/data/models';
import classNames from 'classnames';
import { Tooltip } from 'react-tooltip';
import theme from 'container/theme';
import styled from 'styled-components';
function Services({ mobileMenu, setMobileMenu }) {
  // let { id } = useParams();
  const dispatch = useDispatch();
  const isOpen = useSelector(state => state.utils.isRightSideBarOpen);
  const loading = useSelector(state => state.chat.responseLoading);
  const imageLoading = useSelector(state => state.imageGeneration.loading);

  const model = useSelector(state => state.chat.model);

  const handleChangeModel = model => {
    // window.open(`${siteURL}/${model?.id}`);
    dispatch.chat.setModel(model);
    if (model.value === 'picasso') {
      dispatch.utils.setOpenControls(true);
    }
    if (!loading && !imageLoading) {
      dispatch.chat.setSelectedConversation(null);
      dispatch.chat.setMessages([]);
      // dispatch.chat.getAllConversations(`?model=${model.value}`);
    }
    dispatch.utils.setOpenMobileRightMenu(false);
    if (model.label.toLowerCase() === 'picasso') {
      // dispatch.utils.setOpenControls(true);
    }
  };

  // const getModelId = () => {
  //   if (id) {
  //     const data = config && config.find((item) => id === item.id);
  //     dispatch.chat.setModel(data);
  //   } else {
  //     dispatch.chat.setModel(config[0]);
  //   }
  // };

  useEffect(() => {
    if (!model.value) {
      dispatch.chat.setModel(config[0]);
    }
    // getModelId();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classNames('right__sidebar', isOpen ? 'open' : '')}>
      {config.length &&
        config.map((item, index) => (
          <div
            key={item.label}
            className='right__sidebar-inner'
            style={{
              maxWidth: isOpen ? '' : '80px',
              overflow: 'hidden',
              transition: '0.4s ease',
            }}
          >
            <div className='right__sidebar-access'>
              <div
                onClick={() => {
                  if (!loading && !imageLoading) {
                    if (item?.disabled) {
                      return;
                    }
                    handleChangeModel(item);
                  }
                }}
                className={`content ${
                  model.label === item.label ? 'active' : ''
                } ${item.disabled && 'disabled'}`}
                style={{
                  cursor: loading || imageLoading ? 'not-allowed' : 'pointer',
                  position: 'relative',
                }}
                id={item.id}
              >
                <div
                  id={'id-' + index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexGrow: 1,
                    paddingRight: 15,
                  }}
                >
                  {!isOpen && (
                    <Tooltip
                      anchorSelect={`#id-${index}`}
                      content={item.label}
                      style={{
                        zIndex: '100',
                        background: theme.colors.lightgrey,
                        top: '0px',
                      }}
                    />
                  )}
                  <div className='inner-text'>
                    <img
                      src={item.image}
                      style={{
                        height: '30px',
                        width: '30px',
                        borderRadius: '8px',
                      }}
                      alt='ChatGpt Icon'
                    />

                    <p
                      className='access-text'
                      style={{
                        marginLeft: isOpen ? '' : '80px',
                        whiteSpace: isOpen ? 'nowrap' : 'nowrap',
                      }}
                    >
                      {item.label}{' '}
                      {item.desc && (
                        <span
                          style={{
                            fontSize: '12px',
                            fontWeight: '400',
                            opacity: '0.5',
                            lineHeight: 'inherit',
                          }}
                        >
                          {item.desc}
                        </span>
                      )}
                    </p>
                  </div>
                  {isOpen && (
                    <div>
                      {model.label === item.label && !item.new ? (
                        <img
                          src={assets.tick}
                          style={{ width: '25px' }}
                          alt=''
                        />
                      ) : null}

                      {item.new && <NewChip>New!</NewChip>}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}

export default Services;

const NewChip = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.red};
  font-size: 8px;
  color: ${({ theme }) => theme.colors.primary};
  padding: 2px 4px;
  border-radius: 10px;
  top: 4px;
  right: 4px;
`;
